import React, { FC, useState, useEffect } from "react";
import { FooterLinkModel } from "../../../../lib/shared-models/FooterLink.model";
import { LinksAccordionProps } from "./types/LinksAccordion.types";
import { FooterLink, LinkField } from "../../../../types/types";
import { windowService } from "../../../../utils/window.utils";
import "./styles.scss";
import { withSitecoreContext, Link  } from "@sitecore-jss/sitecore-jss-react";

const LinksAccordion: FC<LinksAccordionProps> = ({
  fields,
  sitecoreContext,
}) => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  //const [isSecondCollapsed, setIsSecondCollapsed] = useState("");
  const [arrayCollapsed, setArrayCollapsed] = useState<string[]>([]);

  const mobileBreakpoint = 768;
  const isEEActive = sitecoreContext.pageEditing;

  useEffect(() => {
    if (typeof window !== 'undefined' && 'customElements' in window) {
      import('@patternfly/pfe-icon-onhighway/dist/pfe-icon.js');
    }
  }, []);

  const onAccordionClick = () => {
    if (windowService().innerWidth <= mobileBreakpoint) {
      setIsCollapsed(!isCollapsed);
    }
  };

  useEffect(() => {
    setArrayCollapsed([]);
  }, [fields]);

  const onSecondLevelClick = (text: string = '') => {
    // isSecondCollapsed === text ? setIsSecondCollapsed("") : setIsSecondCollapsed(text)
    const arr = [...arrayCollapsed];

    const index = arr.indexOf(text);
    if (index > -1) {
      arr.splice(index, 1); // 2nd parameter means remove one item only
    } else {
      arr.push(text);
    }
    setArrayCollapsed(arr);
  };

  const isCollapsable = (text) => {
    return arrayCollapsed.includes(text);
  };

  const accordions = fields?.map((item: FooterLink, i: number) => {
    const model = new FooterLinkModel(item);

    const links = model.list.map((item: FooterLink, index: number) => (
      <div key={index}>
        {(item?.fields?.List?.length ?? 0) > 0 ? (
          <li className="footer-accordion__item">
            <button
              className={`${
                isCollapsable(item.fields?.Link?.value?.text) ? "Open" : ""
              } footer-accordion-secondlevel__button ${
                item.fields?.List?.length == 0
                  ? ""
                  : "footer-accordion-secondlevel__button--is-plain-text"
              }`}
              onClick={() => {
                onSecondLevelClick(item.fields?.Link?.value?.text);
              }}
              key={index.toString() + "button"}
            >
              {(item.fields?.List?.length ?? 0) > 0 && (
                <pfe-icon
                  class="footer-accordion-secondlevel__icon"
                  icon={
                    isCollapsable(item.fields?.Link?.value?.text)
                      ? "cnh-arrow-i-os-downward"
                      : "cnh-arrow-i-os-downward"
                  }
                  size="18"
                />
              )}
              <h5 className="footer-accordion-secondlevel__header">
                <span>{item.fields?.Link?.value?.text}</span>
              </h5>
            </button>
            <ul
              className={`footer-accordion-secondlevel__list ${
                isCollapsable(item.fields?.Link?.value?.text)
                  ? "footer-accordion-secondlevel__list--notcollapsed"
                  : "footer-accordion-secondlevel__list--collapsed"
              }`}
              style={{
                maxHeight: isCollapsable(item.fields?.Link?.value?.text)
                  ? "500px"
                  : "0px",
              }}
              key={index.toString() + "ul"}
            >
              {item.fields?.List?.map((val, i) => (
                <li key={i.toString() + "RoutableSitecoreLink-li"}>
                  <Link
                    field={val.fields?.Link as LinkField}
                    className="footer-accordion-secondlevel__link"
                  />
                </li>
              ))}
            </ul>
          </li>
        ) : (
          <li key={index} className="footer-accordion__item">
            <Link
              field={item.fields?.Link as LinkField}
              className="footer-accordion__link"
              key={index.toString() + "RoutableSitecoreLink2"}
            />
          </li>
        )}
      </div>
    ));

    return (
      <div className="footer-accordion" key={i}>
        <button
          className={
            "footer-accordion__button" +
            (links.length == 0
              ? ""
              : " footer-accordion__button--is-plain-text")
          }
          onClick={onAccordionClick}
        >
          {links.length > 0 && (
            <pfe-icon
              class="footer-accordion__icon"
              icon={
                isCollapsed
                  ? "cnh-arrow-i-os-downward"
                  : "cnh-arrow-i-os-upward"
              }
              size="24"
            />
          )}
          <h5 slot="header" className="footer-accordion__header">
            {isEEActive || links.length == 0 ? (
              <a
                title={model.title?.value}
                href={model.linkUrl}
                onClick={() => window && window.scroll(0, 0)}
              >
                {model.linkText}
              </a>
            ) : (
              <span>{model.title?.value}</span>
            )}
          </h5>
        </button>
        <ul className={`footer-accordion__list`}>{links}</ul>
      </div>
    );
  });

  return <div className="footer-accordion__container">{accordions}</div>;
};

export default withSitecoreContext()(LinksAccordion);
